import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";


export async function getWebsitePlans(
  website_plan_user,
  website_plan_parent = "",
  website_plan_status = "",
  page_no = 0,
  search_key = ""
) {
  try {
    const fd = new FormData();
    fd.append("website_plan_user", website_plan_user);
    fd.append("website_plan_parent", website_plan_parent);
    fd.append("website_plan_status", website_plan_status);
    fd.append("page_no", page_no);
    fd.append("search_key", search_key);

    const response = await axios.post(`${apiBaseUrl}webplan/get_plans`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getWebsitePlans error:", error);
    return { status: false, type: "danger", success: "Failed to fetch plans" };
  }
}

// 🔹 Get Website Plan Report (total, active, inactive)
export async function getWebsitePlanReport(website_plan_user) {
  try {
    const fd = new FormData();
    fd.append("website_plan_user", website_plan_user);

    const response = await axios.post(`${apiBaseUrl}webplan/get_plan_report`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getWebsitePlanReport error:", error);
    return { status: false, type: "danger", success: "Failed to load plan report" };
  }
}

// 🔹 Create or Update Website Plan
export async function createWebsitePlan(formData) {
  try {
    const response = await axios.post(`${apiBaseUrl}webplan/create_plan`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("createWebsitePlan error:", error);
    return { status: false, type: "danger", success: "Failed to save plan" };
  }
}

// 🔹 Delete Website Plan
export async function deleteWebsitePlan(website_plan_id) {
  try {
    const fd = new FormData();
    fd.append("website_plan_id", website_plan_id);

    const response = await axios.post(`${apiBaseUrl}webplan/delete_plan`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("deleteWebsitePlan error:", error);
    return { status: false, type: "danger", success: "Plan delete failed" };
  }
}

// 🔹 Update Website Plan Status
export async function updateWebsitePlanStatus(website_plan_id, website_plan_status) {
  try {
    const fd = new FormData();
    fd.append("website_plan_id", website_plan_id);
    fd.append("website_plan_status", website_plan_status);

    const response = await axios.post(`${apiBaseUrl}webplan/update_plan_status`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("updateWebsitePlanStatus error:", error);
    return { status: false, type: "danger", success: "Plan status update failed" };
  }
}
